export enum PillType {
  SelectAll = "SelectAll",
  SingleSelect = "SingleSelect",
}
